import { render, staticRenderFns } from "./AdminResearch.vue?vue&type=template&id=16070416&scoped=true&"
import script from "./AdminResearch.vue?vue&type=script&lang=js&"
export * from "./AdminResearch.vue?vue&type=script&lang=js&"
import style0 from "./AdminResearch.vue?vue&type=style&index=0&id=16070416&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16070416",
  null
  
)

export default component.exports